'use client';

import { useState, useEffect } from 'react';
import OrdersTable, { Order } from './OrdersTable';

interface AdminDashboardInteractiveProps {
  orders: Order[];
}

export default function AdminDashboardInteractive({
  orders: initialOrders,
}: AdminDashboardInteractiveProps) {
  const [isHydrated, setIsHydrated] = useState(false);
  const [orders, setOrders] = useState(initialOrders);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleStatusChange = (orderId: string, newStatus: Order['status']) => {
    setOrders((prevOrders) =>
      prevOrders.map((order) =>
        order.id === orderId ? {...order, status: newStatus } : order
      )
    );
  };

  if (!isHydrated) {
    return (
      <div className="min-h-screen pt-24 pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="animate-pulse space-y-8">
            <div className="h-12 bg-accent rounded-xl w-1/3"></div>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="h-32 bg-accent rounded-2xl"></div>
              ))}
            </div>
            <div className="h-96 bg-accent rounded-2xl"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <OrdersTable orders={orders} onStatusChange={handleStatusChange} />
    </div>
  );
}